import script from "./ImportPasteInput.vue?vue&type=script&lang=js"
export * from "./ImportPasteInput.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__